import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26576ee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading text-center mb20" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("ユーザ別")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("トレーニングレポート")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "anker-link-box"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("ここ１ヶ月の実施状況")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("実施率")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("正解率")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("トレーニング詳細 ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  id: "latest",
  class: "sub-heading-mt"
}, "ここ1ヶ月の実施状況", -1))
const _hoisted_12 = { style: {"display":"flex"} }
const _hoisted_13 = { class: "mr20 flex-width" }
const _hoisted_14 = { class: "flex-width" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 解答内容 ")
const _hoisted_16 = { class: "center" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { style: {"display":"flex"} }
const _hoisted_19 = { class: "flex-width" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  id: "challenge-rate",
  class: "sub-heading-mt"
}, "実施率", -1))
const _hoisted_21 = { class: "flex-width" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  id: "correct-rate",
  class: "sub-heading-mt"
}, "正解率", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  id: "training-detail",
  class: "sub-heading-mt"
}, "トレーニング詳細", -1))
const _hoisted_24 = { class: "correct-checkbox-box" }

import {
  computed,
  onMounted,
  ref,
  watch,
} from 'vue'
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router'
import { BarChart } from 'vue-chart-3';
import { useUserLearningReportLogic } from '@/logic/report/UserLearningReportLogic';
import { useLastMonthGraph } from '@/logic/report/LastMonthGraphLogic';
import { useChallengeRateGraph } from '@/logic/report/ChallengeRateGraphLogic';
import { useCorrectRateGraph } from '@/logic/report/CorrectRateGraphLogic';
import { useTrainingDetailsTable } from '@/logic/report/TrainingDetailsTableLogic';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();

const store = useStore();
// const managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);

const select = ref<number | null>(null);

const {
  userList,
  data,
  load,
  loading,
  loaded,
} = useUserLearningReportLogic(ref(route.params.project_id));
watch(userList, () => {
  if (route.params.user_id) {
    select.value = Number(route.params.user_id);
  }
});

watch(select, (value) => {
  router.push({
    name: 'UserLearningReport',
    params: {
      user_id: value,
    },
    query: route.query
  });
});

watch(() => route.params.user_id, (value: any) => {
  if (
    route.params.user_id === undefined ||
    value === undefined
  ) {
    return;
  }

  load({
    project_id: route.params.project_id,
    user_id: value,
    daily: route.query.daily,
  });
});
onMounted(() => {
  if (route.params.user_id !== undefined) {
    load({
      project_id: route.params.project_id,
      user_id: route.params.user_id,
      daily: route.query.daily,
    });
  }
});

const {
  chartData: lastMonthChartData,
  option: lastMonthChartOption,
  tableData: lastMonthTableData,
  setData: setLastMonthData,
  tableDataTotalSize: lastMonthTableDataTotalSize,
  tablePageSize: lastMonthTablePageSize,
  changePage: lastMonthChangePage,
} = useLastMonthGraph();

const {
  chartData: challengeRateChartData,
  option: challengeRateChartOption,
  setData: setChallengeRateChartData,
} = useChallengeRateGraph();

const {
  chartData: correctRateChartData,
  option: correctRateChartOption,
  setData: setCorrectRateData,
} = useCorrectRateGraph();

const {
  data: trainingDetailsData,
  setRawData: setTrainingTableData,
  noChallengeOnly,
} = useTrainingDetailsTable();

const is_daily = !!route.query.daily;

watch(data, (newData: any) => {
  setLastMonthData(newData.last_month);
  if (!is_daily) {
    setChallengeRateChartData(newData.challenge_rate);
    setCorrectRateData(newData.correct_rate);
    setTrainingTableData(newData.training_detail);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_scroll_to = _resolveDirective("scroll-to")!
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(managerFlg))
    ? (_openBlock(), _createBlock(_component_el_container, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "box-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("h2", _hoisted_1, [
                    _hoisted_2,
                    is_daily
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "デイリー"))
                      : _createCommentVNode("", true),
                    _hoisted_4
                  ]),
                  _createVNode(_component_el_select, {
                    modelValue: select.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((select).value = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userList), (user) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: user.id,
                          value: user.id,
                          label: user.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _withDirectives(_createElementVNode("div", null, [
                    (_unref(loaded))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (!is_daily)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _withDirectives(_createVNode(_component_el_button, { round: "" }, {
                                  default: _withCtx(() => [
                                    _hoisted_7
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_directive_scroll_to, { element: '#latest', container: 'main.el-main' }]
                                ]),
                                _withDirectives(_createVNode(_component_el_button, { round: "" }, {
                                  default: _withCtx(() => [
                                    _hoisted_8
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_directive_scroll_to, { element: '#challenge-rate', container: 'main.el-main' }]
                                ]),
                                _withDirectives(_createVNode(_component_el_button, { round: "" }, {
                                  default: _withCtx(() => [
                                    _hoisted_9
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_directive_scroll_to, { element: '#correct-rate', container: 'main.el-main' }]
                                ]),
                                _withDirectives(_createVNode(_component_el_button, { round: "" }, {
                                  default: _withCtx(() => [
                                    _hoisted_10
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_directive_scroll_to, { element: '#training-detail', container: 'main.el-main' }]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_unref(BarChart), {
                                chartData: _unref(lastMonthChartData),
                                options: _unref(lastMonthChartOption)
                              }, null, 8, ["chartData", "options"])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_el_table, {
                                data: _unref(lastMonthTableData),
                                size: "small",
                                stripe: "",
                                border: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    prop: "total_answer_time",
                                    label: "解答内容",
                                    width: "80"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_router_link, {
                                        to: { name: 'ProjectLearningCourseHistory', params: { learning_course_id: scope.row.learning_course_id }, query: { user_id: _unref(route).params.user_id } },
                                        target: "_blank",
                                        class: "button-link"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_15
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "learning_course_name",
                                    label: "トレーニングタイトル",
                                    width: "180"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_router_link, {
                                        to: { name: 'ProjectLearningCourseShow', params: { learning_course_id: scope.row.learning_course_id } },
                                        target: "_blank",
                                        class: "button-link"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(scope.row.learning_course_name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "date",
                                    label: "実施日",
                                    width: "150"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "correct_rate",
                                    label: "正解率(%)",
                                    width: "150"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "total_answer_time",
                                    label: "解答タイム(秒)",
                                    width: "150"
                                  })
                                ]),
                                _: 1
                              }, 8, ["data"]),
                              _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_el_pagination, {
                                  layout: "prev, pager, next",
                                  total: _unref(lastMonthTableDataTotalSize),
                                  "page-size": _unref(lastMonthTablePageSize),
                                  onCurrentChange: _unref(lastMonthChangePage)
                                }, null, 8, ["total", "page-size", "onCurrentChange"])
                              ])
                            ])
                          ]),
                          (!is_daily)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, [
                                    _hoisted_20,
                                    _createVNode(_unref(BarChart), {
                                      chartData: _unref(challengeRateChartData),
                                      options: _unref(challengeRateChartOption)
                                    }, null, 8, ["chartData", "options"])
                                  ]),
                                  _createElementVNode("div", _hoisted_21, [
                                    _hoisted_22,
                                    _createVNode(_unref(BarChart), {
                                      chartData: _unref(correctRateChartData),
                                      options: _unref(correctRateChartOption)
                                    }, null, 8, ["chartData", "options"])
                                  ])
                                ]),
                                _hoisted_23,
                                _createElementVNode("div", _hoisted_24, [
                                  _createVNode(_component_el_checkbox, {
                                    label: "未実施のみを表示",
                                    modelValue: _unref(noChallengeOnly),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(noChallengeOnly) ? (noChallengeOnly).value = $event : null))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createVNode(_component_el_table, {
                                  data: _unref(trainingDetailsData),
                                  size: "small",
                                  stripe: "",
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_table_column, {
                                      prop: "learning_course_category",
                                      label: "カテゴリ",
                                      width: "180"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "learning_course_name",
                                      label: "トレーニングタイトル",
                                      width: "180"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createVNode(_component_router_link, {
                                          to: { name: 'ProjectLearningCourseShow', params: { learning_course_id: scope.row.learning_course_id } },
                                          target: "_blank",
                                          class: "button-link"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(scope.row.learning_course_name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "last_challenged_at",
                                      label: "最終実施日",
                                      width: "180"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "do_count",
                                      label: "実施数",
                                      width: "180"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "correct_rate",
                                      label: "平均正解率(%)",
                                      width: "180"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "total_answer_time",
                                      label: "平均解答タイム(秒)",
                                      width: "180"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_directive_loading, _unref(loading)]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})